import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import FormGroup from '@mui/material/FormGroup';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import LzSApp from '@lz-app/App';
import LzXFullPagePublicForm from '@lz-layouts/FullPagePublicForm';

export interface LzPPageRegister {
  className?: string;
  style?: React.CSSProperties;
  bgImg?: string;
}

const LzXPageRegister = (props: LzPPageRegister) => {
  const [username, setUsername] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');

  const onSubmit: React.FormEventHandler<HTMLFormElement> = (event: React.FormEvent<HTMLFormElement>) => {
    // TODO: Write api code
    // NOTE: Make sure to use `newWp` and `cfmWp` instead of `newPassword` and `confirmPassword` when sending back to server
  };

  return (
    <LzXFullPagePublicForm
      heading="Register Account"
      onSubmit={onSubmit}
      bgImg={props.bgImg || LzSApp.register_bg_image}
      className={props.className}
      style={props.style}
    >

      <FormGroup row>
        <TextField fullWidth variant='outlined' label='Email as Username'
          value={username} onChange={(event) => setUsername(event.target.value)} />
      </FormGroup>

      <FormGroup row>
        <TextField fullWidth variant='outlined' type='password' label='New Password'
          value={newPassword} onChange={(event) => setNewPassword(event.target.value)} />
      </FormGroup>

      <FormGroup row>
        <TextField fullWidth variant='outlined' type='password' label='Confirm Password'
          value={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)} />
      </FormGroup>

      <FormGroup row>
        <TextField fullWidth variant='outlined' label='Your Full Name'
          value={name} onChange={(event) => setName(event.target.value)} />
      </FormGroup>

      <FormGroup row>
        <TextField fullWidth variant='outlined' label='Your Phone #'
          value={phone} onChange={(event) => setPhone(event.target.value)} />
      </FormGroup>

      <FormGroup>
        <Grid container>
          <Grid size={{ xs: 6 }}>
            <Link to={'/login'}>
              <KeyboardBackspaceIcon fontSize='small' sx={{ verticalAlign: 'bottom' }} />{' '} Back to Login
            </Link>
          </Grid>
          <Grid size={{ xs: 6 }} style={{ textAlign: 'right' }}>
            <Button type='submit' variant='contained' color='primary'>
              Submit
            </Button>
          </Grid>
        </Grid>
      </FormGroup>

    </LzXFullPagePublicForm >
  );
};

export default LzXPageRegister;
